"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reComment = /\/\*[\s\S]*?\*\//g;
/*
([^\s:;]+?)\s*:\s*         # Property name and colon
(
  (?:
    (?:                    # Begin alternation
      url\(                # Match 'url('
        \s*
        (?:
          (?:[^"')\\]|\\.)*  # Content inside url(), excluding quotes and closing parenthesis
          |
          "(?:[^"\\]|\\.)*"  # Double-quoted strings, handling escaped characters
          |
          '(?:[^'\\]|\\.)*'  # Single-quoted strings, handling escaped characters
        )
        \s*
      \)
      |
      "(?:[^"\\]|\\.)*"     # Double-quoted strings, handling escaped characters
      |
      '(?:[^'\\]|\\.)*'     # Single-quoted strings, handling escaped characters
      |
      [^;"']                # Any character except ';', double or single quotes
    )*?                     # Repeat zero or more times, non-greedy
    \s*
  )
)
(?=;|$)                     # Lookahead for ';' or end of string
*/
var reDeclaration = /([^\s:;]+?)\s*:\s*((?:(?:url\(\s*(?:(?:[^"')\\]|\\.)*|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')\s*\)|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|[^;"'])*?)\s*)(?=;|$)/gi;
var reDoubleQuoted = /&quot;|&#34;|&#x22;/gi;
var reSingleQuoted = /&apos;|&#39;|&#x27;/gi;
var doubleQuote = '"';
var singleQuote = "'";
var empty = '';
function replaceQuoteEntities(str) {
    return str.replace(reDoubleQuoted, doubleQuote)
        .replace(reSingleQuoted, singleQuote);
}
/**
 * Parse inline styles string into object.
 *
 * @param styleString - inline styles string
 * @returns object with styles
 */
function parseInlineStyles(styleString) {
    var styleObject = {};
    var input = replaceQuoteEntities((styleString || empty).replace(reComment, empty));
    var match = reDeclaration.exec(input), property, value;
    while (match !== null) {
        property = match[1].trim();
        value = match[2].trim();
        styleObject[property] = value;
        match = reDeclaration.exec(input);
    }
    return styleObject;
}
exports.parseInlineStyles = parseInlineStyles;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-common@1.0.2/~/@progress/kendo-common/dist/npm/parse-style.js
// module id = 6408
// module chunks = 0